// extracted by mini-css-extract-plugin
module.exports = {"insurance":"_30gNHzjbVl3F","selectedInsurance":"cV6LkcqLjhcS","name":"_2JNPcphRgskT"};